var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 1.66675C5.40033 1.66675 1.66699 5.40008 1.66699 10.0001C1.66699 14.6001 5.40033 18.3334 10.0003 18.3334C14.6003 18.3334 18.3337 14.6001 18.3337 10.0001C18.3337 5.40008 14.6003 1.66675 10.0003 1.66675ZM10.0003 16.6667C6.32533 16.6667 3.33366 13.6751 3.33366 10.0001C3.33366 6.32508 6.32533 3.33341 10.0003 3.33341C13.6753 3.33341 16.667 6.32508 16.667 10.0001C16.667 13.6751 13.6753 16.6667 10.0003 16.6667ZM8.33366 11.8084L13.8253 6.31675L15.0003 7.50008L8.33366 14.1667L5.00033 10.8334L6.17533 9.65842L8.33366 11.8084Z",
    fill: "#1A5C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7aa51eb4e02249ce9aed171e89080070.svg";
export { ForwardRef as ReactComponent };